import { z } from "zod";
export const idParamSchema = z.object({
    id: z.coerce.number().int().positive(),
});
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    // 1500 cubre el universo actual de companies (~1231); ajustar con autocomplete
    // si el catálogo crece significativamente.
    pageSize: z.coerce.number().int().min(1).max(1500).default(25),
    q: z.string().trim().min(1).max(120).optional(),
});
export const paginatedResponse = (item) => z.object({
    items: z.array(item),
    total: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
});
export const errorResponse = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
//# sourceMappingURL=common.js.map